module.exports = __webpack_public_path__ + "img/10.8ca6b33f.png";